export default function hasGrantedAllScopesGoogle(tokenResponse, firstScope, ...restScopes) {
    if (!window.google) return false;

    return window.google.accounts.oauth2.hasGrantedAllScopes(
        tokenResponse,
        firstScope,
        ...restScopes,
    );
}